import { Pipe, PipeTransform } from "@angular/core";

type ByteSizeUnit = "KB" | "MB" | "GB" | "TB";

const UNIT_DIVISORS: Record<ByteSizeUnit, number> = {
	KB: 1024,
	MB: 1024 ** 2,
	GB: 1024 ** 3,
	TB: 1024 ** 4,
};

@Pipe({
	name: "bytesSize",
	standalone: true,
})
export class BytesSizePipe implements PipeTransform {
	transform(value: number | null | undefined, unit: ByteSizeUnit = "MB", fractionDigits = 2): string {
		const safeValue = typeof value === "number" && Number.isFinite(value) ? value : 0;
		const divisor = UNIT_DIVISORS[unit] ?? UNIT_DIVISORS.MB;
		const size = safeValue / divisor;
		const digits = Number.isFinite(fractionDigits) ? Math.max(0, Math.trunc(fractionDigits)) : 2;
		const formatted = new Intl.NumberFormat("en-US", {
			minimumFractionDigits: 0,
			maximumFractionDigits: digits,
		}).format(size);

		return `${formatted} ${unit}`;
	}
}
